<template>
  <div class="room container">
    <div class="grid-container">
      <div class="room__title">
        <h3 class="heading-3 heading-3--light mb-1">
          {{ $t('pageHome.rooms.title') }}
        </h3>
        <h2 class="heading-2 heading-2--light">
          <slot name="room-title"></slot>
          <span class="ml-1">{{ $t('pageHome.rooms.apt') }}</span>
        </h2>
      </div>
      <div class="room__cta">
        <slot name="room-cta"></slot>
      </div>
      <div class="room__mainimg">
        <img :src="mainImg.url" :alt="mainImg.alt" />
      </div>
      <div class="room__description">
        <p>
          <slot name="room-description"></slot>
        </p>
      </div>
      <div class="room__info">
        <slot name="room-info"></slot>
      </div>
      <div class="room__list">
        <slot name="room-list"></slot>
      </div>
      <div class="room__gallery">
        <slot name="room-gallery"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    mainImg: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.grid-container {
  display: grid;
  width: 100%;

  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(min-content, max-content);
  grid-template-areas:
    'heading heading cta cta'
    'mainImg mainImg description description'
    'mainImg mainImg info info'
    'mainImg mainImg list list'
    'mainImg mainImg list list'
    'gallery gallery gallery gallery';

  // grid-template-rows: 25%, 1fr, 2fr, 35%;
  column-gap: 15px;
  row-gap: 8px;
}

.room {
  background-color: hsl(var(--clr-primary-700));
  padding: 30px;
  width: 98%;
  max-width: 11280px;
  margin: 0 auto;
  display: flex;

  align-items: center;
  justify-content: center;

  &__title {
    text-align: center;
    grid-area: heading;
    justify-self: center;
    margin-bottom: 24px;
  }

  &__cta {
    grid-area: cta;
    justify-self: center;
    width: 100%;
  }

  &__mainimg {
    grid-area: mainImg;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  &__description {
    color: hsl(var(--clr-primary-100));
    font-size: 12px;
    justify-self: center;
    font-family: var(--ff-serif);
    text-align: center;
    width: 90%;
    line-height: 1.5;
    grid-area: description;
  }

  &__info {
    grid-area: info;
    justify-self: center;
  }

  &__list {
    grid-area: list;
    justify-self: center;
  }

  &__gallery {
    grid-area: gallery;
  }
}

@media (max-width: 900px) {
  .grid-container {
    grid-template-areas:
      'heading heading cta cta'
      'description description description description'
      'info info list list'
      'mainImg mainImg mainImg mainImg'
      'gallery gallery gallery gallery';

    row-gap: 20px;
    column-gap: 0;

    .room {
      &__info {
        align-self: center;
      }
    }
  }
}

@media (max-width: 600px) {
  .grid-container {
    grid-template-areas:
      'heading heading cta cta'
      'description description description description'
      'info info info info'
      'list list list list'
      'mainImg mainImg mainImg mainImg'
      'gallery gallery gallery gallery';

    .room {
      &__list {
        justify-self: center;
      }
    }
  }
}

@media (max-width: 400px) {
  .grid-container {
    grid-template-areas:
      'heading heading heading heading'
      'cta cta cta cta'
      'description description description description'
      'info info info info'
      'list list list list'
      'mainImg mainImg mainImg mainImg'
      'gallery gallery gallery gallery';
  }
}
</style>
